export const PRODUCTS = [
  {
    id: 'code',
    name: 'CODE',
    tagline: 'programmable git storage',
    module: 'MOD_01',
    code: 'GIT_STORE',
    figure: 'FIG. 1: DAG_TREE',
    meta: [
      { key: 'PROTOCOL', value: 'GIT_NATIVE' },
      { key: 'SYNC', value: 'BI_DIRECTIONAL' },
      { key: 'QUEUE', value: 'MERGE_QUEUE' },
    ],
    description:
      'High-performance, fully programmable git repository storage. API-first and modular, designed for scale with advanced policies for large monorepos. Extensible via event-driven hooks, with bi-directional sync to GitHub and other hosts for seamless migration. Built-in merge queues for high-velocity teams.',
    action: 'INIT_REPO',
  },
  {
    id: 'align',
    name: 'ALIGN',
    tagline: 'intelligent code review',
    module: 'MOD_02',
    code: 'CODE_REV',
    figure: 'FIG. 2: CONSENSUS_MERGE',
    meta: [
      { key: 'ROUTE', value: 'INTELLIGENT' },
      { key: 'POLICY', value: 'OWNERSHIP' },
      { key: 'VELOCITY', value: 'HIGH' },
    ],
    description:
      'API-first code review tooling engineered for high change velocity. Automated change summarisation, risk assessment, and intelligent routing to the right teams and developers. Advanced ownership policies and configurable merge rules keep quality high without slowing down.',
    action: 'OPEN_REVIEW',
  },
  {
    id: 'verify',
    name: 'VERIFY',
    tagline: 'incremental builds',
    module: 'MOD_03',
    code: 'BUILD_SYS',
    figure: 'FIG. 3: EXEC_MATRIX',
    meta: [
      { key: 'INFRA', value: 'SEMI_PERMANENT' },
      { key: 'FORK', value: 'ZFS+FIRECRACKER' },
      { key: 'BUILD', value: 'INCREMENTAL' },
    ],
    description:
      'Incremental build system running on semi-permanent infrastructure. ZFS and Firecracker-based instant VM forks eliminate cold starts — verification begins in milliseconds, not minutes. Fully programmable and extensible build pipelines that adapt to your stack.',
    action: 'RUN_BUILD',
  },
  {
    id: 'deliver',
    name: 'DELIVER',
    tagline: 'release pipelines',
    module: 'MOD_04',
    code: 'REL_PIPE',
    figure: 'FIG. 4: ROLLOUT_SEQ',
    meta: [
      { key: 'PIPE', value: 'PROGRAMMABLE' },
      { key: 'RUNNER', value: 'SELF_HOSTED' },
      { key: 'DEPLOY', value: 'IAC_NATIVE' },
    ],
    description:
      'Programmable release pipelines for any infrastructure with advanced deployment policies and high throughput. Run on managed runners or deploy to your own infrastructure with out-of-the-box IaC templates. Full control over rollout strategy, from canary to blue-green.',
    action: 'DEPLOY',
  },
  {
    id: 'observe',
    name: 'OBSERVE',
    tagline: 'telemetry database',
    module: 'MOD_05',
    code: 'TLM_DB',
    figure: 'FIG. 5: TIME_SERIES_DB',
    meta: [
      { key: 'STORE', value: 'OBJECT_STORAGE' },
      { key: 'FORMAT', value: 'APACHE_ICEBERG' },
      { key: 'COST', value: 'PREDICTABLE' },
    ],
    description:
      'High-performance, API-first telemetry database built on object storage and Apache Iceberg. Ingest, store, and query logs, metrics, and traces at scale with predictable cost and open formats. No vendor lock-in.',
    action: 'QUERY',
  },
  {
    id: 'operate',
    name: 'OPERATE',
    tagline: 'programmable alerting',
    module: 'MOD_06',
    code: 'ALERT_SYS',
    figure: 'FIG. 6: ANOMALY_DET',
    meta: [
      { key: 'DEFINE', value: 'ALERTS_AS_CODE' },
      { key: 'PRECISION', value: 'HIGH' },
      { key: 'RESPONSE', value: 'SUB_SECOND' },
    ],
    description:
      'API-first programmable alerting for your telemetry. High-precision threshold and anomaly detection with sub-second response times. Define alert logic as code, route to the right responders, and trigger automated remediation.',
    action: 'SET_ALERT',
  },
];

export const GLYPH_PATTERN = [
  1, 1, 1, 1, 1, 1, 1, 1,
  1, 1, 1, 1, 1, 1, 1, 1,
  1, 1, 0, 0, 0, 0, 0, 0,
  1, 1, 0, 0, 0, 0, 0, 0,
  1, 1, 0, 0, 0, 0, 0, 0,
  1, 1, 0, 0, 0, 0, 0, 0,
  1, 1, 1, 1, 1, 1, 1, 1,
  1, 1, 1, 1, 1, 1, 1, 1,
];

const TEXTURE_STR = 'CMPND_SYS_CORE ';
const TEXTURE_LINE_COUNT = 45;
const TEXTURE_REPEATS = 3;

export const TEXTURE_LINES = Array.from(
  { length: TEXTURE_LINE_COUNT },
  () => TEXTURE_STR.repeat(TEXTURE_REPEATS),
);
